export default __webpack_public_path__ + "static/media/ssl-logo.383496a6.svg";